export default "__VITE_ASSET__RkCvSDr3__"